import React, { useEffect, useState } from "react";
import { FaTicketAlt, FaTag } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { getEventStatus, getLowestPrice } from "../../utils/helper";
import { DefaultPlaceholder } from "../skeleton/Skeleton";
import { borderColors } from "../../assets/data/Data";

const TopEventDetails = ({ event }) => {
  const navigate = useNavigate();
  const [colorIndex, setColorIndex] = useState(0);
  const remainingTickets = event?.tickets?.reduce(
    (curr, item) => curr + item?.quantity,
    0
  );

  const eventStatus =
    event && event.date
      ? getEventStatus(`${event.date},${event?.time_start}`)
      : "";

  useEffect(() => {
    const colorInterval = setInterval(() => {
      setColorIndex((prevIndex) => (prevIndex + 1) % borderColors.length);
    }, 1000);
    return () => clearInterval(colorInterval);
  }, []);

  return (
    <div
      className={`transition-all duration-500 border-4 bg-white dark:bg-primary-darkBgOther dark:hover:bg-primary-darkBgSecondary dark:hover:duration-500 ease-in-out rounded-2xl shadow-lg overflow-hidden relative flex flex-col cursor-pointer shadow-black/5  ${borderColors[colorIndex]}`}
      onClick={() => navigate(`/event-details/${event?._id}`)}
    >
      <div className="m-3">
        {event?.imageUrl ? (
          <img
            src={event?.imageUrl}
            alt={event._id}
            className="w-full h-64 object-cover rounded-2xl"
          />
        ) : (
          <DefaultPlaceholder />
        )}
      </div>

      <div className="flex-1 flex flex-col">
        <div className="flex items-center justify-between px-4 mb-1">
          <div
            className={`${
              eventStatus === "Live Now"
                ? "dark:text-default-success border dark:border-default-success animate-bounce"
                : eventStatus === "Event Ended"
                ? "text-default-error border dark:border-default-error"
                : "dark:text-gray-200"
            } text-primary-text bg-primary-tag rounded-lg px-2.5 py-1 dark:text-xs`}
          >
            {eventStatus}
          </div>
          {event.tickets?.length > 0 && (
            <div className="flex items-center gap-x-2">
              <FaTag className="dark:text-primary-tag" />
              <span className="font-sans font-medium text-default">
                {`From ${getLowestPrice(event?.tickets)?.toLocaleString()} USD`}
              </span>
            </div>
          )}
        </div>
        <div className="px-4 pb-2 flex-1 h-full pt-1.5">
          <h4 className="text-base xl:text-lg font-medium text-primary-text line-clamp-1 font-poppins">
            {event.title}
          </h4>
        </div>
        <div className="flex items-center justify-between px-3 pb-3.5">
          <div className="text-primary-text dark:text-gray-400 rounded-xl py-0.5 dark:text-sm capitalize flex items-center">
            <img
              src={event?.organizer?.profile}
              alt=""
              className="w-7 h-6 rounded-full mr-0.5"
            />
            {event.organizer?.name}
          </div>
          {event.tickets?.length > 0 && (
            <div className="flex items-center gap-x-2">
              <FaTicketAlt className="dark:text-[#6366f1]" />
              <span className="font-sans font-medium text-default">
                {remainingTickets} Remaining
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TopEventDetails;
